import { ITEM_PER_PAGE, ITEM_PER_PAGE_GRID } from 'src/constants'

import { fillArray } from 'src/helpers/fillArray'

export const getArrayOfSkeletons = (isList: boolean) => {
  return isList ? fillArray(ITEM_PER_PAGE) : fillArray(ITEM_PER_PAGE_GRID)
}
